module.exports = __webpack_public_path__ + "img/novapetroleo.4c68373f.png";